var map = {
	"./img/PB26Team.jpg": 2543,
	"./img/Sp24DataTeam.jpg": 4890,
	"./img/Sp24UITeam.jpg": 8492,
	"./img/Sp25nairrMeeting.jpg": 5947,
	"./img/Sp26nairrMeeting.png": 2148,
	"./projectView.png": 9564,
	"./projects": 9409,
	"./projects.json": 9409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5580;